import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const DrugsOutline = createIcon({
  displayName: 'DrugsOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M15.889 8h-7.778c-1.166 0-2.111-.945-2.111-2.111v-.778c0-1.166.945-2.111 2.111-2.111h7.778c1.166 0 2.111.945 2.111 2.111v.778c0 1.166-.945 2.111-2.111 2.111Z"></path>
        <path d="M15.833 21h-7.666c-1.749 0-3.167-1.418-3.167-3.167v-6.667c0-1.748 1.418-3.166 3.167-3.166h7.667c1.748 0 3.166 1.418 3.166 3.167v6.667c0 1.748-1.418 3.166-3.167 3.166Z"></path>
        <line x1="12" x2="12" y1="12.56" y2="16.78"></line>
        <line x1="14.11" x2="9.89" y1="14.67" y2="14.67"></line>
        <line x1="12" x2="12" y1="5.3" y2="5.81"></line>
        <line x1="9.25" x2="9.25" y1="5.3" y2="5.81"></line>
        <line x1="14.75" x2="14.75" y1="5.3" y2="5.81"></line>
      </g>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const DrugsTwoTone = createIcon({
  displayName: 'DrugsTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="g"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
        color="twoToneStrokeColor"
      >
        <Box
          as="path"
          fill="twoToneFillColor"
          d="M15.889 8h-7.778c-1.166 0-2.111-.945-2.111-2.111v-.778c0-1.166.945-2.111 2.111-2.111h7.778c1.166 0 2.111.945 2.111 2.111v.778c0 1.166-.945 2.111-2.111 2.111Z"
        ></Box>
        <path d="M15.833 21h-7.666c-1.749 0-3.167-1.418-3.167-3.167v-6.667c0-1.748 1.418-3.166 3.167-3.166h7.667c1.748 0 3.166 1.418 3.166 3.167v6.667c0 1.748-1.418 3.166-3.167 3.166Z"></path>
        <Box as="line" stroke="twoToneFillColor" x1="12" x2="12" y1="12.56" y2="16.78"></Box>
        <Box as="line" stroke="twoToneFillColor" x1="14.11" x2="9.89" y1="14.67" y2="14.67"></Box>
        <line x1="12" x2="12" y1="5.3" y2="5.81"></line>
        <line x1="9.25" x2="9.25" y1="5.3" y2="5.81"></line>
        <line x1="14.75" x2="14.75" y1="5.3" y2="5.81"></line>
      </Box>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const Drugs: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={DrugsTwoTone} {...props} />
  default:
    return <CustomIcon as={DrugsOutline} {...props} />
  }
}

export default memo(Drugs)
